// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'table-bolt';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M8.282 12.875H2a1.5 1.5 0 0 1-1.5-1.5V2A1.5 1.5 0 0 1 2 .5h11.25a1.5 1.5 0 0 1 1.5 1.5v3.375M.5 4.625h14.25m-8.886 0v8.165m4.481-8.165V8.75M.5 8.75h9.845m4.87-1.5-4.253 5.162a.29.29 0 0 0-.04.3.27.27 0 0 0 .246.163h1.89v4.5l4.255-5.162a.29.29 0 0 0-.058-.418.268.268 0 0 0-.147-.045h-1.893z'
  />
);

export const viewBox = '0 0 18 18';
